import BlobImage from "../../../../components/BlobImage/BlobImage";
import React from "react";
import { FaUserTie, FaUserFriends } from "react-icons/fa";
import dayjs from "dayjs";
import {
  CustomDatePicker,
  CustomDropdown,
  CustomTextInput,
  CustomFileInput,
} from "../../../../components";

const ParentInformation = ({
  formData,
  errors,
  handleInputChange,
  handleDropdownChange,
  handleDateChange,
  handleMobileChange,
  handleAadharChange,
  handlePincodeChange,
  handleCheckboxChange,
  handleRadioChange,
  handleFatherPhotoChange,
  handleMotherPhotoChange,
  handleGuardianPhotoChange,
  handleNumericInput,
  handlePanChange,
  countryOptions,
  fatherStateOptions,
  motherStateOptions,
  guardianStateOptions,
  occupationOptions,
  incomeOptions,
  styles,
  radioCheckboxStyles,
  translations,
}) => {
  // Fields to disable when "Same Address" is checked
  const isMotherAddressDisabled = formData.motherSameAddress;

  return (
    <>
      {/* ==================== FATHER INFORMATION ==================== */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaUserTie />
        </div>
        <h1 className={styles.headerTitle}>
          {translations.labels?.fatherInformation || "Father Information"}
        </h1>
      </div>

      <div className="row">
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.firstName || "First Name"}
            name="fatherFirstName"
            type="text"
            value={formData.fatherFirstName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.firstNamePlaceholder || "Enter First Name"
            }
            required
            error={errors.fatherFirstName}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.middleName || "Middle Name"}
            name="fatherMiddleName"
            type="text"
            value={formData.fatherMiddleName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.middleNamePlaceholder || "Enter Middle Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.lastName || "Last Name"}
            name="fatherLastName"
            type="text"
            value={formData.fatherLastName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.lastNamePlaceholder || "Enter Last Name"
            }
            required
            error={errors.fatherLastName}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.emailAddress || "Email Address"}
            name="fatherEmail"
            type="email"
            value={formData.fatherEmail}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.fatherEmailPlaceholder ||
              "Enter Father's Email"
            }
            required
            error={errors.fatherEmail}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.phoneNumber || "Phone Number"}
            name="fatherPhone"
            type="text"
            value={formData.fatherPhone}
            inputClassName={`${styles.markInput}`}
            onChange={(e) => handleNumericInput(e, "fatherPhone", 10)}
            placeholder={
              translations.labels?.phoneNumberPlaceholder ||
              "Enter Phone Number"
            }
            maxLength={10}
            error={errors.fatherPhone}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.mobileNumber || "Mobile Number"}
            name="fatherMobile"
            type="text"
            inputClassName={`${styles.markInput}`}
            value={formData.fatherMobile}
            onChange={(e) => handleMobileChange(e, "fatherMobile")}
            placeholder={
              translations.labels?.mobileNumberPlaceholder ||
              "Enter Mobile Number"
            }
            maxLength={10}
            required
            error={errors.fatherMobile}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDatePicker
            label={translations.labels?.dateOfBirth || "Date of Birth"}
            name="fatherDob"
            value={formData.fatherDob ? dayjs(formData.fatherDob) : null}
            onChange={(date) => handleDateChange("fatherDob", date)}
            placeholder={
              translations.labels?.dateOfBirthPlaceholder ||
              "Select Date of Birth"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDatePicker
            label={translations.labels?.anniversary || "Anniversary"}
            name="fatherAnniversary"
            value={
              formData.fatherAnniversary
                ? dayjs(formData.fatherAnniversary)
                : null
            }
            onChange={(date) => handleDateChange("fatherAnniversary", date)}
            placeholder={
              translations.labels?.anniversaryPlaceholder ||
              "Select Anniversary Date"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.panNumber || "PAN Number"}
            name="fatherPan"
            type="text"
            value={formData.fatherPan}
            onChange={(e) => handlePanChange(e, "fatherPan")}
            placeholder={
              translations.labels?.panNumberPlaceholder ||
              "Enter PAN Number (e.g., ABCDE1234F)"
            }
            maxLength={10}
            error={errors.fatherPan}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.aadharNumber || "Aadhar Number"}
            name="fatherAadhar"
            type="text"
            value={formData.fatherAadhar}
            onChange={(e) => handleAadharChange(e, "fatherAadhar")}
            placeholder={
              translations.labels?.aadharNumberAltPlaceholder ||
              "Enter Aadhar Number"
            }
            maxLength={12}
            error={errors.fatherAadhar}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.address1 || "Address Line 1"}
            name="fatherAddress1"
            type="text"
            value={formData.fatherAddress1}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.addressPlaceholder || "Enter Address"
            }
            required
            error={errors.fatherAddress1}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.address2 || "Address Line 2"}
            name="fatherAddress2"
            type="text"
            value={formData.fatherAddress2}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.addressPlaceholder || "Enter Address"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.address3 || "Address Line 3"}
            name="fatherAddress3"
            type="text"
            value={formData.fatherAddress3}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.addressPlaceholder || "Enter Address"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.pincode || "Pincode"}
            name="fatherPincode"
            type="text"
            value={formData.fatherPincode}
            onChange={(e) => handlePincodeChange(e, "fatherPincode")}
            placeholder={
              translations.labels?.pincodePlaceholder || "Enter Pincode"
            }
            maxLength={6}
            required
            error={errors.fatherPincode}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.city || "City"}
            name="fatherCity"
            type="text"
            value={formData.fatherCity}
            onChange={handleInputChange}
            placeholder={translations.labels?.cityPlaceholder || "Enter City"}
            required
            error={errors.fatherCity}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.country || "Country"}
            name="fatherCountry"
            value={formData.fatherCountry}
            onChange={(value) => handleDropdownChange("fatherCountry", value)}
            options={countryOptions}
            placeholder={translations.labels?.selectCountry || "Select Country"}
            required
            error={errors.fatherCountry}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.state || "State"}
            name="fatherState"
            value={formData.fatherState}
            onChange={(value) => handleDropdownChange("fatherState", value)}
            options={fatherStateOptions}
            placeholder={translations.labels?.selectState || "Select State"}
            required
            error={errors.fatherState}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.occupation || "Occupation"}
            name="fatherOccupation"
            value={formData.fatherOccupation}
            onChange={(value) =>
              handleDropdownChange("fatherOccupation", value)
            }
            options={occupationOptions}
            placeholder={
              translations.labels?.selectOccupation || "Select Occupation"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.income || "Annual Income"}
            name="fatherIncome"
            value={formData.fatherIncome}
            onChange={(value) => handleDropdownChange("fatherIncome", value)}
            options={incomeOptions}
            placeholder={translations.labels?.selectIncome || "Select Income"}
            required
            error={errors.fatherIncome}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <CustomFileInput
                label={translations.labels?.profilePhoto || "Profile Photo"}
                name="fatherPhoto"
                value={formData.fatherPhotoOriginal || null}
                onChange={handleFatherPhotoChange}
                accept="image/*"
                placeholder={
                  formData.fatherPhotoOriginal
                    ? formData.fatherPhotoOriginal
                    : "No file chosen"
                }
                buttonText="Choose File"
                error={errors.fatherPhotoOriginal}
              />
            </div>
            {formData.fatherPhotoPath && (
              <BlobImage
                path={formData.fatherPhotoPath}
                alt="father photo"
                style={{
                  width: 72,
                  height: 72,
                  objectFit: "cover",
                  borderRadius: 8,
                  border: "1px solid #dcdcdc",
                  marginTop: 24,
                }}
              />
            )}
          </div>
        </div>
      </div>

      {/* ==================== MOTHER INFORMATION ==================== */}
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaUserFriends />
        </div>
        <h1 className={styles.headerTitle}>
          {translations.labels?.motherInformation || "Mother Information"}
        </h1>
      </div>

      <label className={radioCheckboxStyles.checkboxContainer}>
        <input
          type="checkbox"
          name="motherSameAddress"
          checked={formData.motherSameAddress}
          onChange={handleCheckboxChange}
          className={radioCheckboxStyles.checkboxInput}
        />
        <span className={radioCheckboxStyles.checkboxCustom}></span>
        <span className={radioCheckboxStyles.checkboxLabel}>
          {translations.labels?.sameAddress || "Same as Father's Address"}
        </span>
      </label>

      <div className="row">
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.firstName || "First Name"}
            name="motherFirstName"
            type="text"
            value={formData.motherFirstName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.firstNamePlaceholder || "Enter First Name"
            }
            required
            error={errors.motherFirstName}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.middleName || "Middle Name"}
            name="motherMiddleName"
            type="text"
            value={formData.motherMiddleName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.middleNamePlaceholder || "Enter Middle Name"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.lastName || "Last Name"}
            name="motherLastName"
            type="text"
            value={formData.motherLastName}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.lastNamePlaceholder || "Enter Last Name"
            }
            required
            error={errors.motherLastName}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.emailAddress || "Email Address"}
            name="motherEmail"
            type="email"
            value={formData.motherEmail}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.motherEmailPlaceholder ||
              "Enter Mother's Email"
            }
            required
            error={errors.motherEmail}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.phoneNumber || "Phone Number"}
            name="motherPhone"
            type="text"
            inputClassName={`${styles.markInput}`}
            value={formData.motherPhone}
            onChange={(e) => handleNumericInput(e, "motherPhone", 10)}
            placeholder={
              translations.labels?.phoneNumberPlaceholder ||
              "Enter Phone Number"
            }
            maxLength={10}
            error={errors.motherPhone}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.mobileNumber || "Mobile Number"}
            name="motherMobile"
            type="text"
            value={formData.motherMobile}
            inputClassName={`${styles.markInput}`}
            onChange={(e) => handleMobileChange(e, "motherMobile")}
            placeholder={
              translations.labels?.mobileNumberPlaceholder ||
              "Enter Mobile Number"
            }
            maxLength={10}
            required
            error={errors.motherMobile}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDatePicker
            label={translations.labels?.dateOfBirth || "Date of Birth"}
            name="motherDob"
            value={formData.motherDob ? dayjs(formData.motherDob) : null}
            onChange={(date) => handleDateChange("motherDob", date)}
            placeholder={
              translations.labels?.dateOfBirthPlaceholder ||
              "Select Date of Birth"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDatePicker
            label={translations.labels?.anniversary || "Anniversary"}
            name="motherAnniversary"
            value={
              formData.motherAnniversary
                ? dayjs(formData.motherAnniversary)
                : null
            }
            onChange={(date) => handleDateChange("motherAnniversary", date)}
            placeholder={
              translations.labels?.anniversaryPlaceholder ||
              "Select Anniversary Date"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.panNumber || "PAN Number"}
            name="motherPan"
            type="text"
            value={formData.motherPan}
            onChange={(e) => handlePanChange(e, "motherPan")}
            placeholder={
              translations.labels?.panNumberPlaceholder ||
              "Enter PAN Number (e.g., ABCDE1234F)"
            }
            maxLength={10}
            error={errors.motherPan}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.aadharNumber || "Aadhar Number"}
            name="motherAadhar"
            type="text"
            value={formData.motherAadhar}
            onChange={(e) => handleAadharChange(e, "motherAadhar")}
            placeholder={
              translations.labels?.aadharNumberAltPlaceholder ||
              "Enter Aadhar Number"
            }
            maxLength={12}
            error={errors.motherAadhar}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.address1 || "Address Line 1"}
            name="motherAddress1"
            type="text"
            value={formData.motherAddress1}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.addressPlaceholder || "Enter Address"
            }
            required
            error={errors.motherAddress1}
            disabled={isMotherAddressDisabled}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.address2 || "Address Line 2"}
            name="motherAddress2"
            type="text"
            value={formData.motherAddress2}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.addressPlaceholder || "Enter Address"
            }
            disabled={isMotherAddressDisabled}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.address3 || "Address Line 3"}
            name="motherAddress3"
            type="text"
            value={formData.motherAddress3}
            onChange={handleInputChange}
            placeholder={
              translations.labels?.addressPlaceholder || "Enter Address"
            }
            disabled={isMotherAddressDisabled}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.pincode || "Pincode"}
            name="motherPincode"
            type="text"
            value={formData.motherPincode}
            onChange={(e) => handlePincodeChange(e, "motherPincode")}
            placeholder={
              translations.labels?.pincodePlaceholder || "Enter Pincode"
            }
            maxLength={6}
            required
            error={errors.motherPincode}
            disabled={isMotherAddressDisabled}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomTextInput
            label={translations.labels?.city || "City"}
            name="motherCity"
            type="text"
            value={formData.motherCity}
            onChange={handleInputChange}
            placeholder={translations.labels?.cityPlaceholder || "Enter City"}
            required
            error={errors.motherCity}
            disabled={isMotherAddressDisabled}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.country || "Country"}
            name="motherCountry"
            value={formData.motherCountry}
            onChange={(value) => handleDropdownChange("motherCountry", value)}
            options={countryOptions}
            placeholder={translations.labels?.selectCountry || "Select Country"}
            required
            error={errors.motherCountry}
            disabled={isMotherAddressDisabled}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.state || "State"}
            name="motherState"
            value={formData.motherState}
            onChange={(value) => handleDropdownChange("motherState", value)}
            options={motherStateOptions}
            placeholder={translations.labels?.selectState || "Select State"}
            required
            error={errors.motherState}
            disabled={isMotherAddressDisabled}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.occupation || "Occupation"}
            name="motherOccupation"
            value={formData.motherOccupation}
            onChange={(value) =>
              handleDropdownChange("motherOccupation", value)
            }
            options={occupationOptions}
            placeholder={
              translations.labels?.selectOccupation || "Select Occupation"
            }
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <CustomDropdown
            label={translations.labels?.income || "Annual Income"}
            name="motherIncome"
            value={formData.motherIncome}
            onChange={(value) => handleDropdownChange("motherIncome", value)}
            options={incomeOptions}
            placeholder={translations.labels?.selectIncome || "Select Income"}
            required
            error={errors.motherIncome}
          />
        </div>
        <div className="col-lg-4 px-2 col-md-6 col-sm-12">
          <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <CustomFileInput
                label={translations.labels?.profilePhoto || "Profile Photo"}
                name="motherPhoto"
                value={formData.motherPhotoOriginal || null}
                onChange={handleMotherPhotoChange}
                accept="image/*"
                placeholder={
                  formData.motherPhotoOriginal
                    ? formData.motherPhotoOriginal
                    : "No file chosen"
                }
                buttonText="Choose File"
                error={errors.motherPhotoOriginal}
              />
            </div>
            {formData.motherPhotoPath && (
              <BlobImage
                path={formData.motherPhotoPath}
                alt="mother photo"
                style={{
                  width: 72,
                  height: 72,
                  objectFit: "cover",
                  borderRadius: 8,
                  border: "1px solid #dcdcdc",
                  marginTop: 24,
                }}
              />
            )}
          </div>
        </div>
      </div>

      {/* ==================== IS CHILD STAYING WITH GUARDIAN ==================== */}
      <div className={radioCheckboxStyles.radioSection}>
        <label className={radioCheckboxStyles.radioSectionLabel}>
          {translations.labels?.isChildStayingWithGuardian ||
            "Is Child Staying with Guardian?"}{" "}
          <span className={radioCheckboxStyles.required}>*</span>
        </label>
        <div className={radioCheckboxStyles.radioGroup}>
          <label className={radioCheckboxStyles.radioContainer}>
            <input
              type="radio"
              name="isChildStayingWithGuardian"
              value="yes"
              checked={formData.isChildStayingWithGuardian === "yes"}
              onChange={handleRadioChange}
              className={radioCheckboxStyles.radioInput}
            />
            <span className={radioCheckboxStyles.radioCustom}></span>
            <span className={radioCheckboxStyles.radioLabel}>
              {translations.labels?.yes || "Yes"}
            </span>
          </label>
          <label className={radioCheckboxStyles.radioContainer}>
            <input
              type="radio"
              name="isChildStayingWithGuardian"
              value="no"
              checked={formData.isChildStayingWithGuardian === "no"}
              onChange={handleRadioChange}
              className={radioCheckboxStyles.radioInput}
            />
            <span className={radioCheckboxStyles.radioCustom}></span>
            <span className={radioCheckboxStyles.radioLabel}>
              {translations.labels?.no || "No"}
            </span>
          </label>
        </div>
        {errors.isChildStayingWithGuardian && (
          <span className={radioCheckboxStyles.errorText}>
            {errors.isChildStayingWithGuardian}
          </span>
        )}
      </div>

      {/* ==================== GUARDIAN INFORMATION (Conditional) ==================== */}
      {formData.isChildStayingWithGuardian === "yes" && (
        <>
          <div className={styles.header}>
            <div className={styles.headerIcon}>
              <FaUserTie />
            </div>
            <h1 className={styles.headerTitle}>
              {translations.labels?.guardianInformation ||
                "Guardian Information"}
            </h1>
          </div>

          <div className="row">
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.firstName || "First Name"}
                name="guardianFirstName"
                type="text"
                value={formData.guardianFirstName}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.firstNamePlaceholder ||
                  "Enter First Name"
                }
                required
                error={errors.guardianFirstName}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.middleName || "Middle Name"}
                name="guardianMiddleName"
                type="text"
                value={formData.guardianMiddleName}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.middleNamePlaceholder ||
                  "Enter Middle Name"
                }
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.lastName || "Last Name"}
                name="guardianLastName"
                type="text"
                value={formData.guardianLastName}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.lastNamePlaceholder || "Enter Last Name"
                }
                required
                error={errors.guardianLastName}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.emailAddress || "Email Address"}
                name="guardianEmail"
                type="email"
                value={formData.guardianEmail}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.guardianEmailPlaceholder ||
                  "Enter Guardian's Email"
                }
                required
                error={errors.guardianEmail}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.phoneNumber || "Phone Number"}
                name="guardianPhone"
                type="text"
                inputClassName={styles.markInput}
                value={formData.guardianPhone}
                onChange={(e) => handleNumericInput(e, "guardianPhone", 10)}
                placeholder={
                  translations.labels?.phoneNumberPlaceholder ||
                  "Enter Phone Number"
                }
                maxLength={10}
                error={errors.guardianPhone}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.mobileNumber || "Mobile Number"}
                name="guardianMobile"
                type="text"
                value={formData.guardianMobile}
                onChange={(e) => handleMobileChange(e, "guardianMobile")}
                placeholder={
                  translations.labels?.mobileNumberPlaceholder ||
                  "Enter Mobile Number"
                }
                maxLength={10}
                required
                error={errors.guardianMobile}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomDatePicker
                label={translations.labels?.dateOfBirth || "Date of Birth"}
                name="guardianDob"
                value={
                  formData.guardianDob ? dayjs(formData.guardianDob) : null
                }
                onChange={(date) => handleDateChange("guardianDob", date)}
                placeholder={
                  translations.labels?.dateOfBirthPlaceholder ||
                  "Select Date of Birth"
                }
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomDatePicker
                label={translations.labels?.anniversary || "Anniversary"}
                name="guardianAnniversary"
                value={
                  formData.guardianAnniversary
                    ? dayjs(formData.guardianAnniversary)
                    : null
                }
                onChange={(date) =>
                  handleDateChange("guardianAnniversary", date)
                }
                placeholder={
                  translations.labels?.anniversaryPlaceholder ||
                  "Select Anniversary Date"
                }
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.panNumber || "PAN Number"}
                name="guardianPan"
                type="text"
                value={formData.guardianPan}
                onChange={(e) => handlePanChange(e, "guardianPan")}
                placeholder={
                  translations.labels?.panNumberPlaceholder ||
                  "Enter PAN Number (e.g., ABCDE1234F)"
                }
                maxLength={10}
                error={errors.guardianPan}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.aadharNumber || "Aadhar Number"}
                name="guardianAadhar"
                type="text"
                value={formData.guardianAadhar}
                onChange={(e) => handleAadharChange(e, "guardianAadhar")}
                placeholder={
                  translations.labels?.aadharNumberAltPlaceholder ||
                  "Enter Aadhar Number"
                }
                maxLength={12}
                error={errors.guardianAadhar}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.address1 || "Address Line 1"}
                name="guardianAddress1"
                type="text"
                value={formData.guardianAddress1}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.addressPlaceholder || "Enter Address"
                }
                required
                error={errors.guardianAddress1}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.address2 || "Address Line 2"}
                name="guardianAddress2"
                type="text"
                value={formData.guardianAddress2}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.addressPlaceholder || "Enter Address"
                }
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.address3 || "Address Line 3"}
                name="guardianAddress3"
                type="text"
                value={formData.guardianAddress3}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.addressPlaceholder || "Enter Address"
                }
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.pincode || "Pincode"}
                name="guardianPincode"
                type="text"
                value={formData.guardianPincode}
                onChange={(e) => handlePincodeChange(e, "guardianPincode")}
                placeholder={
                  translations.labels?.pincodePlaceholder || "Enter Pincode"
                }
                maxLength={6}
                required
                error={errors.guardianPincode}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomTextInput
                label={translations.labels?.city || "City"}
                name="guardianCity"
                type="text"
                value={formData.guardianCity}
                onChange={handleInputChange}
                placeholder={
                  translations.labels?.cityPlaceholder || "Enter City"
                }
                required
                error={errors.guardianCity}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomDropdown
                label={translations.labels?.country || "Country"}
                name="guardianCountry"
                value={formData.guardianCountry}
                onChange={(value) =>
                  handleDropdownChange("guardianCountry", value)
                }
                options={countryOptions}
                placeholder={
                  translations.labels?.selectCountry || "Select Country"
                }
                required
                error={errors.guardianCountry}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomDropdown
                label={translations.labels?.state || "State"}
                name="guardianState"
                value={formData.guardianState}
                onChange={(value) =>
                  handleDropdownChange("guardianState", value)
                }
                options={guardianStateOptions}
                placeholder={translations.labels?.selectState || "Select State"}
                required
                error={errors.guardianState}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomDropdown
                label={translations.labels?.occupation || "Occupation"}
                name="guardianOccupation"
                value={formData.guardianOccupation}
                onChange={(value) =>
                  handleDropdownChange("guardianOccupation", value)
                }
                options={occupationOptions}
                placeholder={
                  translations.labels?.selectOccupation || "Select Occupation"
                }
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <CustomDropdown
                label={translations.labels?.income || "Annual Income"}
                name="guardianIncome"
                value={formData.guardianIncome}
                onChange={(value) =>
                  handleDropdownChange("guardianIncome", value)
                }
                options={incomeOptions}
                placeholder={
                  translations.labels?.selectIncome || "Select Income"
                }
                required
                error={errors.guardianIncome}
              />
            </div>
            <div className="col-lg-4 px-2 col-md-6 col-sm-12">
              <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <div style={{ flex: 1 }}>
                  <CustomFileInput
                    label={translations.labels?.profilePhoto || "Profile Photo"}
                    name="guardianPhoto"
                    value={formData.guardianPhotoOriginal || null}
                    onChange={handleGuardianPhotoChange}
                    accept="image/*"
                    placeholder={
                      formData.guardianPhotoOriginal
                        ? formData.guardianPhotoOriginal
                        : "No file chosen"
                    }
                    buttonText="Choose File"
                    error={errors.guardianPhotoOriginal}
                  />
                </div>
                {formData.guardianPhotoPath && (
                  <BlobImage
                    path={formData.guardianPhotoPath}
                    alt="guardian photo"
                    style={{
                      width: 72,
                      height: 72,
                      objectFit: "cover",
                      borderRadius: 8,
                      border: "1px solid #dcdcdc",
                      marginTop: 24,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ParentInformation;
